function toggleWpmlDropdown (dropdownElement) {
  dropdownElement.classList.toggle('open')
}

function closeWpmlDropdownOnClickOutside (event, dropdownElement) {
  if (!dropdownElement.classList.contains('open')) {
    return
  }

  if (event.target.id === 'navigation-lang-button' || event.target.id === 'navigation-lang-dropdown') {
    return
  }

  if (event.target.classList.contains('wpml-ls-native') || event.target.classList.contains('wpml-ls-link')) {
    return;
  }

  dropdownElement.classList.remove('open')
}

export default function wpmlDropdown () {
  const triggerButton = document.querySelector('#navigation-lang-button')
  const dropdownElement = document.querySelector('#navigation-lang-dropdown')

  if (!triggerButton || !dropdownElement) {
    return
  }

  triggerButton.addEventListener('click', () => toggleWpmlDropdown(dropdownElement))
  document.addEventListener('click', event => closeWpmlDropdownOnClickOutside(event, dropdownElement))
}